import { t } from "../i18n/t";

/** Norwegian label for a finding's `confidence` (route-scenario robustness). */
export function confidenceLabel(value: string): string {
  if (value === "scenario") return t("finding.confidenceScenario");
  if (value === "shortest_only") return t("finding.confidenceShortest");
  if (value === "plausible_only") return t("finding.confidencePlausible");
  return t("finding.confidenceRobust");
}
